"use client";

import { Suspense } from "react";
import Link from "next/link";
import type { ButtonProps } from "app/_components/components/Button";
import { Button } from "app/_components/components/Button";
import { BaseLink } from "./BaseLink";

export function CreditCardApplyLink({
  isBusiness,
  label,
  referralCode,
  ...props
}: {
  isBusiness?: boolean;
  referralCode?: string;
  label: string;
} & ButtonProps) {
  let baseHref = "https://creditcard.exchange.gemini.com/credit-card/apply";

  if (isBusiness) baseHref += "?source=smb";

  return (
    <Suspense
      fallback={
        <Button
          asChild
          id="credit-card-page-header-apply-button"
          variant="theme"
          {...props}
        >
          <Link href={baseHref}>{label}</Link>
        </Button>
      }
    >
      <BaseLink
        href={baseHref}
        id="credit-card-page-header-apply-button"
        label={label}
        referralCode={referralCode}
        {...props}
      />
    </Suspense>
  );
}
